import MuiCheckbox from '@mui/material/Checkbox'
import styled from 'styled-components'

const defaultProps = {}
const propTypes = {}

const StyledCheck = styled(MuiCheckbox)`
  .MuiCheckbox-root {
    font-size: 24px;
  }
`

export const Checkbox = props => {
  return <StyledCheck {...props} />
}

Checkbox.defaultProps = defaultProps
Checkbox.propTypes = propTypes

export default Checkbox
